import React from 'react'
import FeatureItem from './FeatureItem'
import { ChangelogItem } from '../types'

interface ChangelogVersionProps {
  version: string
  date: string
  features?: string[] | ChangelogItem[] | false
  improvements?: string[] | ChangelogItem[] | false
  fixes?: string[] | ChangelogItem[] | false
}

const ChangelogVersion: React.FC<ChangelogVersionProps> = React.memo(
  ({ version, date, features, improvements, fixes }) => {
    const slug = version.replace(/\./g, '')

    // Helper function to check if item is a ChangelogItem object
    const isChangelogItem = (item: any): item is ChangelogItem => {
      return typeof item === 'object' && item !== null && 'message' in item
    }

    // Helper function to render items (supports both string[] and ChangelogItem[])
    const renderItems = (
      items: string[] | ChangelogItem[],
      type: 'feature' | 'improvement' | 'fix',
    ) => {
      return items.map((item, index) => {
        if (isChangelogItem(item)) {
          return (
            <FeatureItem
              key={`${type}-${index}`}
              type={type}
              description={item.message}
              icon={item.icon}
              admin={item.admin}
            />
          )
        } else {
          return (
            <FeatureItem
              key={`${type}-${index}`}
              type={type}
              description={item}
            />
          )
        }
      })
    }

    return (
      <div
        id={`v${slug}`}
        className="changelog-item js-changelog-item mb-8 pb-6"
        style={{
          borderBottom: '1px solid var(--changelog-border)',
        }}
      >
        <header className="changelog-header mb-4">
          <h3
            className="changelog-version text-2xl font-bold mb-2"
            style={{ color: 'var(--changelog-text)' }}
          >
            <a
              href={`#v${slug}`}
              className="no-underline"
              style={{
                color: 'var(--changelog-link)',
                textDecoration: 'none',
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.color = 'var(--changelog-link-hover)'
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.color = 'var(--changelog-link)'
              }}
            >
              {version}
            </a>
          </h3>
          <p
            className="changelog-date text-lg"
            style={{ color: 'var(--changelog-text-subdued)' }}
          >
            {date}
          </p>
        </header>

        <div className="changelog-update-descriptions space-y-2">
          {features &&
            Array.isArray(features) &&
            features.length > 0 &&
            renderItems(features, 'feature')}

          {improvements &&
            Array.isArray(improvements) &&
            improvements.length > 0 &&
            renderItems(improvements, 'improvement')}

          {fixes &&
            Array.isArray(fixes) &&
            fixes.length > 0 &&
            renderItems(fixes, 'fix')}
        </div>

        <div className="changelog-link" />
      </div>
    )
  },
)

export default ChangelogVersion
